module.exports = __webpack_public_path__ + "fonts/HKGrotesk-Bold.3d35049.otf";